export const EXPORT_RTB_LOG = 'exportRtbLog';
export const GET_RTB_LOG = 'getRtbLog';